import { render, staticRenderFns } from "./ExitRegister.vue?vue&type=template&id=15589a4e&scoped=true"
import script from "./ExitRegister.vue?vue&type=script&lang=js"
export * from "./ExitRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15589a4e",
  null
  
)

export default component.exports